module.exports = __webpack_public_path__ + "img/marzo2026.b96be497.png";